// extracted by mini-css-extract-plugin
export default {"thumbnailWrapper":"oQPJJJsqXa"};